import BaseDecorator from './baseDecorator';

export default class SizedContainer extends BaseDecorator {
	/**
	 * Updates the width and height of the container to its current dimensions as specificed by the CSS.
	 * This is useful for ensuring the children size themselves correctly and wrap properly, or allowing scrolling.
	 *
	 * @returns {Promise<any>} Promise that resolves when the update is complete
	 */
	async update() {
		this.logger.log(`[${this.update.name}]`);

		const css = {
			width: this.$el.width() ?? 0,
			height: this.$el.height() ?? 0,
		};
		this.$el.css(css);
		this.logger.debug(`Updated container size:`, { css });

		return Promise.resolve();
	}
}
